// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".image-upload-popup__files-container[data-v-79f66058]{max-height:500px;overflow-x:hidden;overflow-y:auto}.image-upload-popup__file-row[data-v-79f66058]{max-height:165px}.image-upload-popup__delete-image-icon[data-v-79f66058]{color:#E6493B;font-size:40px;line-height:100px;cursor:pointer;margin-right:20px}.upload-file-name[data-v-79f66058]{font-size:18px}\n", ""]);
// Exports
module.exports = exports;
